/**
 * The Fidèle films (brand/LOOK_SYSTEM_v1.md § 3.4; WEBSITE_DESIGN_v2.md § 8): every <video data-fdl-film>
 * is muted, looped and inline, shows its poster first, loads nothing until it is near the viewport,
 * plays only while in view, and never loads at all when the visitor prefers reduced motion or has
 * Save-Data on (the poster stays as the still). Phones get the smaller source.
 */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const saveData = Boolean(navigator.connection && navigator.connection.saveData);

function sourceFor(video) {
  const small = video.dataset.srcSmall;
  const large = video.dataset.srcLarge || small;
  return window.innerWidth < 750 ? small || large : large;
}

function load(video) {
  if (video.dataset.loaded) return;
  const src = sourceFor(video);
  if (!src) return;
  video.src = src;
  video.dataset.loaded = '1';
}

function play(video) {
  if (reduce.matches || saveData) return;
  load(video);
  const attempt = video.play();
  if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
}

function setup(root = document) {
  const videos = root.querySelectorAll('video[data-fdl-film]:not([data-fdl-ready])');
  if (!videos.length) return;
  if (!('IntersectionObserver' in window)) {
    videos.forEach((v) => {
      v.dataset.fdlReady = '1';
      play(v);
    });
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const v = entry.target;
        if (entry.isIntersecting) play(v);
        else if (!v.paused) v.pause();
      }
    },
    { rootMargin: '200px 0px', threshold: 0.01 }
  );
  videos.forEach((v) => {
    v.dataset.fdlReady = '1';
    v.muted = true;
    io.observe(v);
  });
}

reduce.addEventListener?.('change', () => {
  if (reduce.matches) document.querySelectorAll('video[data-fdl-film]').forEach((v) => v.pause());
});

setup();
document.addEventListener('shopify:section:load', (event) => setup(event.target));
